import { checkboxClasses, svgIconClasses, formControlLabelClasses, CSSObject, styled } from '@mui/material'

import { FormControlLabel as FormControlLabelBase } from '../../utils/shared/FormControlLabel'
import { FieldHelperText as UnstyledFieldHelperText } from '../field-helper-text/field-helper-text'

export const FormControlLabel = styled(FormControlLabelBase)<{ error?: boolean }>(({ theme, error }) => ({
  justifyContent: 'flex-start',
  alignItems: 'flex-start',

  [`& .${checkboxClasses.root}`]: {
    marginTop: 3,

    [`& .${svgIconClasses.root}`]: {
      color: error ? theme.palette.error[500] : 'inherit',
    },
  },

  [`.${formControlLabelClasses.label}`]: {
    ...(theme.typography['Lato Body 2'] as CSSObject),
  },

  a: {
    color: theme.palette.primary.main,
  },
}))

export const FieldHelperText = styled(UnstyledFieldHelperText)(({ theme }) => ({
  marginLeft: theme.spacing(5),
  marginTop: theme.spacing(1),
}))
